<template>
  <div :style="{width: width}" :class="isBackstage?'backstage-box':''">
    <div class="titles" v-if="title != ''" :style="{textAlign: frameType == 'textarea'?'left':''}">{{title}}</div>
    <div class="contents" v-if="frameType=='image'" :style="{width:width}">
      <div class="imgs-con" data-radio="1:1">
        <div class="content-box">
          <div class="tips" v-if="url===''">
            <a-icon type="file-image" class="default-icon"/>
          </div>
          <img :style="{maxWidth: width,maxHeight: width}" :src="url" v-else />
        </div>
      </div>
      <div class="texts">
        <span>{{$t('descriptions.recommendSize')}}：{{requireSize}}</span>
<!--        <span style="margin-left: 10px">{{acceptType}}格式</span>-->
      </div>
      <div class="btns-con" v-if="isEdit">
        <material-select :type="1" @selected="handleSelected">
          <template slot="body">
            <a-button type="primary">
              {{$t('actionTitles.changeCover')}}
            </a-button>
          </template>
        </material-select>
        <a-button type="danger" style="margin-left: 10px" @click="handleDelete" v-if="url!=''" >
          {{$t('actionTitles.delete')}}
        </a-button>
      </div>
    </div>
    <div class="contents" v-if="frameType=='audio'" :style="{width:width}">
      <div class="m-list">
        <audio controls="controls" alt="example" :src="url"></audio>
      </div>
      <div class="btns-con" v-if="isEdit">
        <material-select :type="2" @selected="handleSelected">
          <template slot="body">
            <a-button type="primary">
              {{$t('actionTitles.changeCover')}}
            </a-button>
          </template>
        </material-select>
        <a-button type="danger" style="margin-left: 10px" @click="handleDelete" v-if="url!=''">
          {{$t('actionTitles.delete')}}
        </a-button>
      </div>
    </div>
    <div class="contents" v-if="frameType=='textarea'" :style="{width: '100%'}" >
      <a-textarea v-model="textValue" @change="handleSelected(textValue)" :auto-size="{ minRows: 3, maxRows: 5 }" :disabled="!isEdit"></a-textarea>
    </div>
    <div class="contents" v-if="frameType == 'input'" :style="{width: '100%'}">
      <a-input v-model="textValue" @change="handleSelected(textValue)" :disabled="!isEdit"/>
    </div>
  </div>
</template>

<script>
import MaterialSelect from "@/components/MaterialSelect";
import { mapGetters } from "vuex";
export default {
  components: { MaterialSelect },
  props: {
    requireSize: {
      default: "1920*1080",
      type: String,
    },
    acceptType: {
      default: "PNG",
      type: String,
    },
    url: {
      type: String,
    },
    width: {
      default: "290px",
      type: String,
    },
    // isImage: {
    //   default: true,
    //   type: Boolean,
    // },
    title: {
      type: String,
      required: true,
    },
    frameType:{
      default: 'image',
      type: String
    },
    inputValue: {
      type: String,
    },
    isEdit: {
      type: Boolean,
      default: true,
    },
    isBackstage: {
      type: Boolean,
      default: false,
    }
  },
  watch: {
    inputValue(newVal) {
      this.textValue = newVal
    }
  },
  data(){
    return {
      textValue: this.inputValue
    }
  },
  computed: { ...mapGetters([ "userInfo"]) },

  methods: {
    handleSelected(value) {
      this.$emit("updateData", value);
    },
    handleDelete() {
      this.$emit("deleteData");
    }
  },
};
</script>

<style lang="less" scoped>
  .titles{
    font-size: 14px;
    margin: 20px 0;
  }
  .contents{
    .imgs-con{
      position: relative;
      overflow: hidden;
      height: 0;
      &[data-radio="1:1"]{
        padding-top: calc(100% * 1 / 1);
      }
      .content-box{
        position: absolute;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background-color: #2f2f2f;
        display: flex;
        justify-content: center;
        align-items: center;
        border: 1px solid #555;
        .tips{
          display: flex;
          justify-content: center;
          align-items: center;
          flex-wrap: wrap;
          width: 100%;
          .default-icon{
            font-size: 40px;
            color:#ffffff;
          }
          div{
            display: inline-block;
            width: 100%;
            text-align: center;
            margin-top: 10px;
          }
        }
      }

    }
    .texts{
      margin-top: 10px;
      text-align: center;
      font-size: 14px;
    }
    .btns-con{
      display: flex;
      justify-content: center;
      margin-top: 10px;
      .changeCoverBtn {
        background-color: #7101ad;
        border: #7101ad;
      }
    }
  }
.holder {
  position: relative;
  background: #333;
  border:1px solid #555;
  padding-top:50px;
  .m-list {
    height: 60px;
    padding: 10px 0;
    text-align: center;
    width: 100%;
  }
  .default-icon {
    font-size: 40px;
    margin-bottom: 10px;
  }

}

  .backstage-box{
    .titles{
      font-size: 12px;
      text-align: center;
      margin: 0 0 10px 0;
    }
    .contents{
      .imgs-con{
        .content-box{
          background-color: #d8dde1;
          border: 1px solid #d8dde1;
          .tips{
            display: flex;
            justify-content: center;
            align-items: center;
            flex-wrap: wrap;
            width: 100%;
            .default-icon{
              font-size: 40px;
              color:#ffffff;
            }
            div{
              display: inline-block;
              width: 100%;
              text-align: center;
              margin-top: 10px;
            }
          }
        }

      }
      .texts{
        color: #999;
        font-size: 12px;
      }
      .btns-con{
        display: flex;
        justify-content: center;
        margin-top: 10px;
      }
    }
  }
</style>
